import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { usePreferenceService } from 'hooks/preference';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const AlertSettings = () => {
  const { create, read } = usePreferenceService();

  const [email, setEmail] = useState('');
  const [is_saving, setIsSaving] = useState(false);
  const [preference, setPreference] = useState({});

  useEffect(() => {
    read().then(({ preferences: [preference] }) => {
      if (!preference) return;
      setPreference(preference);
      setEmail(preference.emails?.alert || '');
    });
  }, []);

  const submit = async () => {
    if (!email) return toast.error('Email is required');

    let result = null;
    const data = { emails: { ...(preference.emails || {}), alert: email } };
    try {
      setIsSaving(true);
      result = await create({ data });
    } finally {
      setIsSaving(false);
    }

    if (result) {
      setPreference(result);
      toast.success(`Alert settings saved successfully`);
    }
  };

  return (
    <BasicInfoSection title="Alerts Configuration">
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Sentry">
            <SimpleInput value={email} onInput={setEmail} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <Button loading={is_saving} disabled={is_saving || !email} text="Save" onClick={submit} />
        </GridColumn>
      </GridRow>
    </BasicInfoSection>
  );
};
